import Vue from "vue"
import App from "./App.vue"
import store from "@/core/store"
import router from "@/core/services/router.service"
import * as Sentry from "@sentry/vue";
import {version} from '/public/config.json';

import '@/core/plugins/plugin-service-provider'
import '@/core/directives/directive-service-provider'
import '@/core/mixins/mixin-service-provider'
import '@/core/filters/filter-service-provider'

import {INITIALIZE_STATIC_CONFIG} from "@/core/store/modules/config/constants";

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        Vue,
        dsn: process.env.VUE_APP_SENTRY_DSN,
        integrations: [Sentry.browserTracingIntegration({router})],
        release: version
    });
}

Vue.config.productionTip = false;

window.eventBus = new Vue({})
new Vue({
    router,
    store,
    render: h => h(App),
    created() {
        store.dispatch(INITIALIZE_STATIC_CONFIG)
    }
}).$mount("#app");